<script setup lang="ts">
import { SVGIcons, type SVGName } from '@/SVGs';
import { computed } from 'vue';

interface Props {
  icon: SVGName;
  width: number | string;
  height: number | string;
  fill?: string;
}

const props = defineProps<Props>();

const icon = computed(() => {
  const item = SVGIcons[props.icon];

  if (!item) {
    return null;
  }

  return item;
});
</script>

<template>
  <component
    v-if="icon"
    :is="icon"
    :width="width"
    :height="height"
    :fill="fill"
  />
</template>
